import SignupFormComponent from './SignupFormComponent'

export default SignupFormComponent
